import React, { useState } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Box,
  InputAdornment,
  Typography,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import backImg from "../../common/assests/backImg.png";
import { toast } from "react-toastify";
import { handleForgetApi } from "../../api";
import CustomBtn from "../../common/customButton/CustomBtn";

const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    background: "#fff",
    fontFamily: "Heebo",
    "& fieldset": { borderColor: "#E7E7E7" },
    "&:hover fieldset": { borderColor: "#D7D7D7" },
    "&.Mui-focused fieldset": { borderColor: "#065F46" },
  },
};

const ForgotPassword = ({ onNext, setActiveTab, onBack }) => {
  const [email, setEmail] = useState("");
  const [btnDisabale, setBtnDisable] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateEmail = (email) => {
    const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return pattern.test(email);
  };

  const handlesendCode = async () => {
    if (!email) {
      toast.warning("Email Required");
      return;
    }
    if (!validateEmail(email)) {
      toast.error("Please provide a valid email address.");
      return;
    }
    try {
      setLoading(true);
      setBtnDisable(true);
      const response = await handleForgetApi(email);
      const refId = response.refData;
      toast.success("Email Verified !");
      setEmail("");
      setActiveTab(1);
      onNext(refId);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      setBtnDisable(false);
      toast.error(error.message);
      console.log("error", error);
    }
  };

  return (
    <>
      <DialogContent sx={{ padding: "20px" }}>
        <Box sx={{ marginTop: '15px', paddingLeft: '10px' }}>
          <Typography
            sx={{ display: "flex", flexDirection: "row", gap: '10px', width: "20%", alignItems: "center", cursor: "pointer" }}
            onClick={onBack}
          >
            <img src={backImg} alt="backImg" style={{ height: "29px", width: "29px" }} />
            <Typography sx={{ color: "#065F46", fontWeight: "500", fontSize: "20px" }}>Back</Typography>
          </Typography>
        </Box>
      </DialogContent>

      <DialogTitle sx={{ fontSize: { xs: "20px", sm: '24px' }, fontWeight: "700", fontFamily: "Heebo", paddingLeft: '35px' }}>
        Forgot Password
      </DialogTitle>
      <DialogTitle sx={{ marginTop: "-27px", fontSize: "14px", fontWeight: "400", fontFamily: "Heebo", opacity: "0.5", paddingLeft: '35px' }}>
        Enter your mail we will send you a Code
      </DialogTitle>

      <DialogContent sx={{ width: "95%", margin: "auto", marginTop: "10px" }}>
        <Typography sx={{ marginBottom: "8px", textAlign: "left", fontSize: { xs: "14px", sm: "14px" }, fontWeight: "600", fontFamily: "Heebo", marginLeft: "4px", color: "#362B24" }}>
          Email
        </Typography>
        <TextField
          fullWidth
          size="small"
          type="email"
          placeholder="Type your email"
          value={email}
          onChange={(e) => { if (e.target.value.trim() !== "" || e.target.value === "") setEmail(e.target.value); }}
          sx={inputSx}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <EmailOutlinedIcon sx={{ color: "#8B8B8B", fontSize: 18 }} />
              </InputAdornment>
            ),
          }}
        />
      </DialogContent>

      <DialogActions sx={{ width: "90%", margin: "auto", marginBottom: "25px", display: 'flex', justifyContent: 'center' }}>
        <CustomBtn onClick={handlesendCode} text="Send Code" disable={btnDisabale} loading={loading} />
      </DialogActions>
    </>
  );
};

export default ForgotPassword;
